import { noop } from 'lodash';
import keyBy from 'lodash/keyBy';
import mapValues from 'lodash/mapValues';
import { DepromiseMap } from './types';

export function sleep(ms = 0): Promise<void> {
  return new Promise((resolve) => window.setTimeout(resolve, ms));
}

export async function delay<T>(ms: number, value: T): Promise<T> {
  await sleep(ms);
  return value;
}

export function mapPromises<T extends object, K extends keyof T>(
  promises: T,
): Promise<DepromiseMap<T>> {
  const keys = Object.keys(promises) as K[];

  return Promise.all(
    keys.map((key) => {
      return (promises[key] as any as Promise<any>).then((result) => ({
        key,
        result,
      }));
    }),
  ).then((resultsWithKey) => {
    return mapValues(keyBy(resultsWithKey, 'key'), 'result') as any;
  });
}

export function swallowPromise(p?: Promise<any>): void {
  if (!p || !p.then) {
    return;
  }

  p.then(() => {
    noop();
  }).catch(() => {
    noop();
  });
}
